import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = signed out

  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: skip /me when returning from OAuth; AuthCallback exchanges the session first.
    if (window.location.hash?.includes("session_id=")) {
      setUser(false);
      return;
    }
    check();
  }, [check]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
    return data;
  };

  const completeGoogleLogin = null; // Emergent connector OAuth removed from customer auth — site uses its own JWT login

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      setUser(false);
    }
  };

  const refreshUser = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      /* keep current */
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, completeGoogleLogin, refreshUser, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}
